import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { matchingPasswords } from 'src/app/theme/utils/app-validators';
import { ActivatedRoute, Router } from '@angular/router'
import { ApiService } from 'src/app/shared/services/api.service';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password-customer.component.html',
  styleUrls: ['./reset-password-customer.component.scss']
})
export class ResetPasswordCustomerComponent implements OnInit {
  
  ResetPasswordCustomerForm: FormGroup;
  token: string | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private notification: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token') || '';
    this.validateToken(this.token);
    this.ResetPasswordCustomerForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      cpassword: ['', [Validators.required, Validators.minLength(6)]]
    },{validator: matchingPasswords('password', 'cpassword')});
  }

  onResetPasswordCustomerFormSubmit(): void {
    if (this.ResetPasswordCustomerForm.valid) {
      const formValues = this.ResetPasswordCustomerForm.value;
      if (formValues.password !== formValues.cpassword) {
        this.notification.error('Passwords do not match');
        return;
      }

      // Handle form submission
      let data={
        password: formValues.password ,
        token:this.token,
      }
     

      this.apiService.updateResetPasswordCustomer(data).subscribe(
        (response: any) => {
          if (response['response']['status'] === 1) {
            this.notification.success(response['response']['message']);
            console.log('Redirecting to sign-in page...');
            this.router.navigate(["/sign-in"]);
          } else {
            this.notification.error(response['response']['message']);
          }
        },
        (error) => {
          console.error('Error occurred:', error);
          this.notification.error('An error occurred while processing the request.');
        }
      ); 
    }
  }

  validateToken(token){    
    if(token){
      this.apiService.resetPasswordCustomerToken(token).subscribe(
        (response: any) => {
          if (response['response']['status'] == 1) {
            this.ResetPasswordCustomerForm.enable();
          } else {
            this.notification.error(response['response']['message']);
            this.router.navigate(['/sign-in']);
          }
        }
      );
    }
  }
}
